import AnimatedText from '../AnimatedText/AnimatedText';
import { TimelineEvent } from '../Timeline/Timeline';
import { useTransition } from '../../contexts/TransitionContext';
import useWindowDimensions from '../../hooks/useWindowDimentions';
import './Header.scss';
import { Icons } from '../Icons/Icons';
import { useMinimap } from '../../contexts/MinimapContext';
import { useMusic } from '../../contexts/MusicContext';
import { useState } from 'react';
import AboutModal from '../AboutModal/AboutModal';

interface HeaderProps {
  activeEvent?: TimelineEvent;
}

const Header: React.FC<HeaderProps> = ({ activeEvent }) => {
  const { setIsSceneLoaded, setIsPageTransitioning } = useTransition();
  const windowDimensions = useWindowDimensions();
  const { showMinimap, toggleMinimap } = useMinimap();
  const { isPlaying, setIsPlaying, fadeAndNavigate } = useMusic();
  const [isAboutModalOpen, setIsAboutModalOpen] = useState(false);

  const handleLogoClick = () => {
    setIsSceneLoaded(false);
    setIsPageTransitioning(true);
    fadeAndNavigate('/?preloader=true');
  };

  const handleAboutBtnClick = () => {
    setIsAboutModalOpen(true);
  };

  const handleSupportBtnClick = () => {
    window.open(`https://buy.stripe.com/3csdSa8jO1HM8Rq4gg`, '_blank');
  };

  return (
    <>
      <div className="header">
        <div className="header-content">
          <div className="logo" onClick={handleLogoClick}>
            Museum of <br /> Digital Influence
          </div>
          <div className="current-timeline-year">
            <AnimatedText id={activeEvent?.year + ' ' + activeEvent?.title} text={activeEvent?.year || ''} />
          </div>
          {windowDimensions.width > 768 ? (
            <div className="btns">
              <div className="btn about-btn" onClick={handleAboutBtnClick}>
                About
              </div>
              <div className="btn support-btn" onClick={handleSupportBtnClick}>
                Support project
              </div>
            </div>
          ) : (
            <div className="btns">
              <div className="btn about-btn" onClick={handleAboutBtnClick}>
                {Icons.QuestionIcon}
              </div>
              <div className="btn support-btn" onClick={handleSupportBtnClick}>
                {Icons.SupportIcon}
              </div>
              <div
                className={`btn menu-btn open-minimap-btn ${showMinimap ? 'active' : ''}`}
                onClick={(e) => {
                  e.stopPropagation();
                  toggleMinimap();
                }}
              >
                {Icons.MenuIcon}
              </div>
              <div className={`btn menu-btn music-btn ${isPlaying ? 'active' : ''}`} onClick={() => setIsPlaying(!isPlaying)}>
                {Icons.MenuMusicBtn}
              </div>
            </div>
          )}
        </div>
        <h1>
          <AnimatedText
            id={activeEvent?.year + ' ' + activeEvent?.title}
            text={activeEvent?.title || ''}
            className="header-title"
          />
        </h1>
      </div>
      <AboutModal isOpen={isAboutModalOpen} onClose={() => setIsAboutModalOpen(false)} />
    </>
  );
};

export default Header; 